import React, { ReactElement, useEffect, useState } from 'react';
import CatalogTypeItem from './catalog-type-item';
import { CourseActivity, CourseType, RemoteOrganizer } from '../types';
import ActivityItem from '../activities/activity-item';

interface CatalogItemProps {
  title: string;
  index?: number;
  types?: CourseType[];
  activities: CourseActivity[];
  organizers: RemoteOrganizer[];
  searchFilterText: string;
}

// eslint-disable-next-line react/prop-types
export default function CatalogItem({ searchFilterText, activities, organizers, types, title }: CatalogItemProps): ReactElement {
  // eslint-disable-next-line react/prop-types
  const hasActivities = activities.length > 0;
  // eslint-disable-next-line react/prop-types
  const hasTypes = types.length > 0;
  const [open, setOpen] = useState(false);
  useEffect(() => {
    setOpen(!!searchFilterText);
  }, [searchFilterText]);
  const toggle = (): void => setOpen(!open);
  const activityItems =
    (open &&
      // eslint-disable-next-line react/prop-types
      activities.map((a) => (
        <ActivityItem
          key={a.id || a.courseId || a.title}
          id={a.id}
          title={a.title}
          description={a.description}
          organizer={a.organizer}
          type={a.type}
          date={a.date}
          time={a.time}
          day={a.day}
          requiresMembership={a.requiresMembership}
          isBookedUp={a.isBookedUp}
          allowsReserves={a.allowsReserves}
          imageUri={a.imageUri}
          link={a.link}
          activities={a.activities}
          isRegistrationOpen={a.isRegistrationOpen}
          bookable={a.bookable}
          numberOfOccurrences={a.numberOfOccurrences}
          organizers={organizers}
          url={a.url}
        />
      ))) ||
    [];
  const catalogTypeItem =
    // eslint-disable-next-line react/prop-types
    (open && types.map((t) => <CatalogTypeItem key={t.title} title={t.title} activities={t.activities} organizers={organizers} />)) || [];
  let subMenuIcon;
  if (hasActivities || hasTypes) {
    subMenuIcon = (
      <div className="toggle-submenu">
        <div className="toggle-submenu-icon" />
      </div>
    );
  }

  return hasActivities || hasTypes ? (
    <li className={`menu-item ${hasActivities ? 'menu-item--has-children' : ''} ${open ? 'open' : ''}`}>
      <a onClick={toggle}>
        <span className="menu-item--link-inner">
          <span className="menu-item--link-hover">{title}</span>
        </span>
        {subMenuIcon}
      </a>
      <div className="sub-menu">
        <ul>
          {catalogTypeItem}
          {activityItems}
        </ul>
      </div>
    </li>
  ) : null;
}
CatalogItem.displayName = 'CatalogItem';
